import ActionsForm from '@/shared/mixins/actionsForm'
import AutocompleteZ from '@/components/forms/AutocompleteZ'
import ExpenseMixin from '@/views/private/finance/expenses/travelexpenses/mixins/ExpenseMixin.js'
import { loading } from '@/shared/utils/UIHelper'
import OcurrenceRepository from '@/shared/http/repositories/realestate/ocurrence'
// import EnterpriseUnityRepository from '@/shared/http/repositories/realestate/enterpriseunity'
import EnterpriseRepository from '@/shared/http/repositories/realestate/enterprise'
import Multiselect from 'vue-multiselect'
import localStoreHelper from '@/shared/utils/localStoreHelper.js'
export default {
  name: 'searchocurrence',
  mixins: [ActionsForm, ExpenseMixin],
  components: {
    AutocompleteZ,
    Multiselect
  },
  data () {
    return {
      title: 'Lista de Chamados',
      dataspersonalizadas: false,
      problemaRaiz: [],
      patologias: [],
      dataempreendimento: [],
      statusocorrencia: [],
      patologiaInternoArray: [],
      patologiaArray: [],
      empreendimentoInternoArray: [],
      empreendimentoArray: [],
      TecnicoIdData: {
        value: null,
        options: [],
        required: false,
        state: null,
        code: null
      },
      SearchItems: {},
      formSearch: {
        pathology: [],
        enterprise: [],
        periodoEnum: 0,
        filtroPersonalizado: false,
        dataInicio: null,
        dataFim: null,
        statusOcorrencia: null
      },
      Nome: {
        value: null,
        options: [],
        required: false,
        state: null,
        code: null
      },
      types: [
      ],
      value: '',
      selectedPatologia: null
    }
  },
  watch: {
    patologiaInternoArray () {
      this.formSearch.pathology = this.patologiaInternoArray.map(x => x.value)
    },
    empreendimentoInternoArray () {
      this.formSearch.enterprise = this.empreendimentoInternoArray.map(x => x.id)
    }
  },
  mounted () {
    // this.GetProblemaRaiz()
    this.getEmpreendimento()
    this.GetPatologia()
    // this.GetAllEmpreendimento()
    // this.GetStatusOcorrencia()
    this.GetStatusRelatorioInsumos()
  },
  methods: {
    Search () {
      loading.pop()
      loading.push()
      let aux = {...this.formSearch}
      localStoreHelper.controleOcorrencia.custoTotal(aux)
      this.$emit('search', aux)
      loading.close()
    },
    Clear () {
      localStoreHelper.controleOcorrencia.custoTotal(null)
      this.patologiaInternoArray = []
      this.formSearch.pathology = []
      this.empreendimentoInternoArray = []
      this.formSearch.enterprise = []
      this.formSearch.periodoEnum = 0
      this.formSearch.dataFinal = null
      this.formSearch.dataInicio = null
      this.formSearch.statusOcorrencia = null
      let input = document.querySelector('.btn-periodos-active')
      if (input != null) {
        input.classList.remove('btn-periodos-active')
        input.classList.add('btn-periodos')
      }
    },
    GetPatologia () {
      loading.push()
      OcurrenceRepository.GetPatologia()
        .then(Response => {
          this.patologiaArray = Response.data
          loading.pop()
        })
        .catch(Error => {
          loading.pop()
        })
    },
    getEmpreendimento () {
      EnterpriseRepository.GetEmpreendimentoByInsumos()
        .then((Response) => {
          this.empreendimentoArray = Response.data
        })
    },
    opcoes () {
      this.dataspersonalizadas = !this.dataspersonalizadas
    },
    filter (obj) {
      this.typeSearch = obj.target.id
      if (obj.target.id === 'semanal') {
        const now = new Date()
        this.formSearch.periodoEnum = 1

        var diferencaPSegunda = now.getDay() - 1
        var diferencaPSexta = (5 - now.getDay())

        const monday = new Date()
        monday.setDate(now.getDate() - diferencaPSegunda)

        const friday = new Date()
        friday.setDate(now.getDate() + diferencaPSexta)

        this.formSearch.dataInicio = monday
        this.formSearch.dataFinal = friday
        this.dataspersonalizadas = false
      }

      if (obj.target.id === 'mensal') {
        const now = new Date()
        this.formSearch.periodoEnum = 0

        const firstDay = new Date(now.getFullYear(), now.getMonth(), 1)

        const lastDay = new Date(now.getFullYear(), now.getMonth() + 1, 0)

        this.formSearch.dataFinal = lastDay
        this.formSearch.dataInicio = firstDay
        this.dataspersonalizadas = false
      }

      if (obj.target.id === 'anual') {
        const now = new Date()
        this.formSearch.periodoEnum = 2

        const firstDay = new Date(now.getFullYear(), 0, 1)

        const lastDay = new Date(now.getFullYear(), 11, 31)

        this.formSearch.dataFinal = lastDay
        this.formSearch.dataInicio = firstDay
        this.dataspersonalizadas = false
      }

      if (obj.target.id === 'personalizado') {
        this.dataspersonalizadas = true
        // this.formSearch.dataFinal = new Date()
        // this.formSearch.dataInicio = new Date()
        this.formSearch.periodoEnum = 3
      }
      let id = obj.target.id
      document.querySelectorAll('.btn-periodos-active').forEach((element) => {
        element.classList.remove('btn-periodos-active')
        element.classList.add('btn-periodos')
      })
      document.getElementById(id).classList.toggle('btn-periodos')
      document.getElementById(id).classList.toggle('btn-periodos-active')
    },
    addTag (newTag) {
      const tag = {
        text: newTag,
        code: newTag.substring(0, 2) + Math.floor((Math.random() * 10000000))
      }
      this.options.push(tag)
      this.value.push(tag)
    },
    GetStatusRelatorioInsumos () {
      OcurrenceRepository.GetStatusRelatorioInsumos()
        .then(Response => {
          loading.pop()
          this.statusocorrencia = Response.data
        })
        .catch(Error => {
          loading.pop()
        })
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/realestate/totalCost/components/searchTotalCost/searchTotalCost.js